import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'

import Button from './Button'
import Icon from './Icon'

import { trackEvent } from '../../utils/tracking'

const SocialButton = ({
  url,
  icon,
  extraClass,
  analyticsExtra,
  forceAnchorElement,
  target,
  children
}) => (
  // NOTE: the onClick even only works _despite_ link because
  // it opened in a different tab (_target=blank)
  <Button
    className={classnames(extraClass, 'button button--plain social-button mr2')}
    onClick={() =>
      trackEvent(
        'SocialButton',
        (analyticsExtra ? analyticsExtra + '-' : '') + icon
      )}
    forceAnchorElement={forceAnchorElement}
    target={target}
    href={url}
  >
    <Icon icon={icon} />
    {children}
  </Button>
)

SocialButton.propTypes = {
  url: PropTypes.string.isRequired,
  icon: PropTypes.string,
  analyticsExtra: PropTypes.string
}

export default SocialButton



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/SocialButton.js